import React, { Component } from 'react';
import axios from "axios";
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { getValueCookie } from '../../services/cookieService';

class ShippingAddress extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      shippingAddresses: this.props.addresses || [],
      selectedAddress: null,
      showModal: false,
      newAddress: {
        customerNo: '',
        name: '',
        street: '',
        city: '',
        state: '',
        zipCode: ''
      },
      isLoading: false
    };
  }

  // Handle dropdown selection
  handleAddressSelect = (address) => {
    this.setState({ selectedAddress: address });
    // Update invoice shipping address
    this.props.updateSelectedShippingAddress(address)
  }

  // Open modal
  handleShowModal = () => {
    this.setState({ showModal: true });
  }

  // Close modal and reset form
  handleCloseModal = () => {
    this.setState({ 
      showModal: false,
      newAddress: {
        customerNo: '',
        name: '',
        street: '',
        city: '',
        state: '',
        zipCode: ''
      }
    });
  }

  // Handle form input changes
  handleInputChange = (field, value) => {
    this.setState({
      newAddress: {
        ...this.state.newAddress,
        [field]: value
      }
    });
  }

  // Save new address
  handleSaveAddress = async () => {
    const { newAddress } = this.state;
    
    // Basic validation
    if (!newAddress.name || !newAddress.street || !newAddress.city) {
      alert('Please fill in all required fields');
      return;
    }

    this.setState({ isLoading: true });

    try {
      const url = 'https://backv2.portalmanager.pro'
        let responseBack;
        const payload = {
            data: {
                companyId: Number(getValueCookie('CompanyId')),
                customerNo: this.props.customerNo,
                shipping_name: newAddress.name,
                shipping_street: newAddress.street,
                shipping_city: newAddress.city,
                shipping_state: newAddress.state,
                shipping_zip: newAddress.zipCode,
            }
        };
        let query = "/sales/create-shipping-address-for-customer";

        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data
            }
        ).catch(error => {
            console.log(error)
        })
      // For demo purposes, we'll simulate saving with a timeout
      if(responseBack.status.code === 1){

      }
      
      // Add to addresses list and select it
      const savedAddress = payload.data;
      const { addresses } = this.props;
      const updatedAddresses = [...addresses, savedAddress];
      
      this.setState({
        // shippingAddresses: updatedAddresses,
        selectedAddress: savedAddress,
        isLoading: false,
        showModal: false,
        newAddress: {
          customerNo: '',
          name: '',
          street: '',
          city: '',
          state: '',
          zipCode: ''
        }
      });
      
      this.props.updateSelectedShippingAddress(savedAddress)
      this.props.updateShippingAddressList(updatedAddresses);

    } catch (error) {
      console.error('Error saving address:', error);
      this.setState({ isLoading: false });
      alert('Error saving address. Please try again.');
    }
  }

  render() {
    const { showModal, newAddress, isLoading } = this.state;
    const { addresses = [], selectedAddress = null} = this.props;

    return (
      <div className='col'>
        {/* Dropdown for selecting shipping address */}
        <Dropdown>
          <Dropdown.Toggle variant="outline-secondary" id="shipping-dropdown">
            {selectedAddress.shipping_name ? selectedAddress.shipping_name : 'Default (Customer Address)'}
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {addresses.length > 0 ?
              addresses.map((address) => (
                <Dropdown.Item 
                  key={address.id}
                  onClick={() => this.handleAddressSelect(address)}
                >
                  <strong>{address.shipping_name}</strong>
                  <br />
                  <small className="text-muted">{`${address.shipping_street}, ${address.shipping_city}, ${address.shipping_state} ${address.shipping_zip}`}</small>
                </Dropdown.Item>
              ))
              :<></>
            }
            <Dropdown.Divider />
            <Dropdown.Item onClick={this.handleShowModal}>
              <i className="fas fa-plus"></i> Add New Address
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* Display selected address */}
        {selectedAddress.shipping_name && (
          <div className="mt-3 p-3 border rounded">
            <h6>Selected Shipping Address:</h6>
            <strong>{selectedAddress.shipping_name}</strong>
            <br />
            {`${selectedAddress.shipping_street}, ${selectedAddress.shipping_city}, ${selectedAddress.shipping_state} ${selectedAddress.shipping_zip}`}
          </div>
        )}

        {/* Modal for adding new address */}
        <Modal show={showModal} onHide={this.handleCloseModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Add New Shipping Address</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Customer No.</Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  value={this.props.customerNo}
                  onChange={(e) => this.handleInputChange('customerNo', e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Address Name *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., Home, Office"
                  value={newAddress.name}
                  onChange={(e) => this.handleInputChange('name', e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Street Address *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Main Street 123"
                  value={newAddress.street}
                  onChange={(e) => this.handleInputChange('street', e.target.value)}
                />
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>City *</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="City"
                      value={newAddress.city}
                      onChange={(e) => this.handleInputChange('city', e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g., GA, CA, NY, TX"
                      maxLength="2"
                      value={newAddress.state}
                      onChange={(e) => this.handleInputChange('state', e.target.value.toUpperCase())}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Zip Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="12345"
                      maxlength="5"
                      value={newAddress.zipCode}
                      onChange={(e) => this.handleInputChange('zipCode', e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSaveAddress}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save Address'}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ShippingAddress;